import {shortDateTime, shortDateTimeUser} from "@/lib/format.tsx";
import {CurrentUserContext} from "@/lib/queries/accounts.ts";
import {AccountFeatureFlags} from "@/lib/types/accounts.ts";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";
import {getCurrentTimezone} from "@/lib/types/datetime.ts";

export const getUserHasFeature = (feature_flags?: AccountFeatureFlags[]): ((name: string) => boolean) => {
  return (name: string): boolean => {
    if (!feature_flags) {
      return false;
    }
    return feature_flags.some((f) => f.name === name);
  };
};

export const getDefaultShortDateTime = (date: string): string =>
  shortDateTime(date, DateFormatName.DEFAULT, TimeFormatName.DEFAULT, getCurrentTimezone());

export const DEFAULT_USER_CONTEXT = {
  user: undefined,
  hasUp2Services: false,
  pinnedDashboards: [],
  brand: {
    // more restrictive
    isDefault: false,
    name: "Uptime.com",
    phone: "+1 877-910-3129",
    email: "support@uptime.com",
    salesEmail: "sales@uptime.com",
    address: "5380 Gulf of Mexico Dr.\\nSte 105\\nLongboat Key, FL 34228",
    statusPageURL: "https://status.uptime.com",
    videoTutorialsURL: "https://www.youtube.com/channel/UCFSfPCnC0x08CPobke0vEHA/featured",
    siteURL: "",
    android: "",
    ios: "",
  },
  accountAccounts: {
    items: [],
  },
  status: {
    date: "",
    title: "",
  },
  userHasFeature: () => {
    return false;
  },
};

export const DEFAULT_PUBLIC_USER_CONTEXT = {
  timezone: getCurrentTimezone(),
  currentDateFormat: DateFormatName.DEFAULT,
  currentTimeFormat: TimeFormatName.DEFAULT,
  getShortDateTime: getDefaultShortDateTime,
  ...DEFAULT_USER_CONTEXT,
};

export const getPublicUserContext = (context?: CurrentUserContext) => {
  const user = context?.user;
  if (!user) {
    return DEFAULT_PUBLIC_USER_CONTEXT;
  }
  const account = user.account;
  const timezone = account.timezone;
  const currentDateFormat = user.current_date_format ?? DateFormatName.DEFAULT;
  const currentTimeFormat = user.current_time_format ?? TimeFormatName.DEFAULT;
  const getShortDateTime = (date: string) => shortDateTimeUser(date, user);
  const userHasFeature = getUserHasFeature(account.feature_flags);
  return {timezone, currentDateFormat, currentTimeFormat, getShortDateTime, userHasFeature, ...context};
};
